// cSpell:disable
import type { FunctionComponent } from "react";

import { SCMPYoutubeVideo } from "~/components/scmp-youtube-video";
import { VideoPlayMode } from "~/components/scmp-youtube-video/enums";

import {
  Container,
  Description,
  Header,
  HeaderContainer,
  StyledSand,
  VideoContainer,
} from "./styles";

export const HearFromOurReaders: FunctionComponent = () => (
  <Container>
    <HeaderContainer>
      <Header>Hear from our readers</Header>
      <Description>
        Check out these videos to learn more about how we help our readers to stay informed and
        knowledgeable.
      </Description>
    </HeaderContainer>
    <VideoContainer>
      <SCMPYoutubeVideo
        enableAutoPlay={false}
        index={0}
        initialVideoPlayMode={VideoPlayMode.Manual}
        isEnabledImaManager={false}
        isHeroVideo={false}
        isMuteVideo={false}
        title="Why Posties?"
        youtubeVideoId="4BEoOktaz1o"
      />
      <SCMPYoutubeVideo
        enableAutoPlay={false}
        index={1}
        initialVideoPlayMode={VideoPlayMode.Manual}
        isEnabledImaManager={false}
        isHeroVideo={false}
        isMuteVideo={false}
        title="Why Posties?"
        youtubeVideoId="2CsP90S_S00"
      />
    </VideoContainer>
    <StyledSand />
  </Container>
);

HearFromOurReaders.displayName = "HearFromOurReaders";
